export * from "./dist/search-insights-node.mjs";
import aa from "./dist/search-insights-node.mjs";
export default aa;
